import { loadOrders } from '@deliveryteam-spa-orders-vue/refs/RecentOrders';
import { authState } from '@/ui-plus/useAuth';
import { toast } from '@/ui-plus/sonner';
import { pusherClient } from '@deliveryteam-spa-orders-vue/pusherClient';

export let courierNotifierChannel: ReturnType<typeof pusherClient['subscribe']> | undefined;
export const subscribeToCourierNotifier = () => {
    if (!authState.value.accessTokenPayload?.id) {
        toast.error('unable to subscribe to courier notifier');
        return;
    }
    if (courierNotifierChannel) return;
    courierNotifierChannel = pusherClient.subscribe(`private-courier.${authState.value.accessTokenPayload.id}`);
    // TODO: handle connection errors
    courierNotifierChannel
        .bind('order-updated', function (data: any) {
            if (data.deliveryteamOrderId && data.deliveryteamId) {
                loadOrders(data.deliveryteamId, [data.deliveryteamOrderId]);
            }
        });
}

// export const unsubscribeFromCourierNotifier = () => {
//     if (courierNotifierChannel) {
//         courierNotifierChannel.unbind_all();
//         courierNotifierChannel.unsubscribe();
//         courierNotifierChannel = undefined;
//     }
// }

export const listenCourierNotifier = () => {
    if (!authState.value.accessTokenPayload?.id) {
        return;
    }
    subscribeToCourierNotifier();
}

// export const disconnectCourierNotifier = () => {
//     unsubscribeFromCourierNotifier();
// }
